"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync, Vue } from "vue-property-decorator";
import { PaymentController } from "@/service/newProdect";
import QuestionSlot from "@/components/QuestionSlot.vue";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
let PaymentNewDeviceInfo = class extends Vue {
  constructor() {
    super(...arguments);
    this.tip_dialog = null;
    this.dialog = new UiDialogController();
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  closeDialog() {
    this.dialog.visible = false;
    this.tip_dialog = null;
  }
  changeRemotes(data) {
    return __async(this, null, function* () {
      if (data.tips) {
        this.tip_dialog = data.tips;
        this.dialog.visible = true;
      }
      yield this._options.changeModels(data.id);
      this.$emit("calculation", true);
    });
  }
  changeModels(data) {
    return __async(this, null, function* () {
      if (data.tips) {
        this.tip_dialog = data.tips;
        this.dialog.visible = true;
      }
      yield this._options.changeCategorys();
      this.$emit("calculation", true);
    });
  }
  changeCategorys(data) {
    return __async(this, null, function* () {
      if (data.tips) {
        this.tip_dialog = data.tips;
        this.dialog.visible = true;
      }
      yield this._options.changeGoods();
      yield this._options.changeConfigs();
      this.$emit("calculation", true);
    });
  }
};
__decorateClass([
  PropSync("options", {
    default: function() {
      return new PaymentController();
    }
  })
], PaymentNewDeviceInfo.prototype, "_options", 2);
PaymentNewDeviceInfo = __decorateClass([
  Component({
    components: { QuestionSlot, UiDialog }
  })
], PaymentNewDeviceInfo);
export {
  PaymentNewDeviceInfo as default
};
